//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { CommonActions } from '../../../Reducer/CommonReducer';
import M_WOS_BASIC from './M_WOS_BASIC';
import { useSearch1 } from './M_WOS_BASIC_Query';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

function M_WOS_BASICF() {
  //#region 변수
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [rowData1, setRowData1] = useState([]);
  const [searchClick, setSearchClick] = useState(false);
  const searchRef = useRef({
    searchText: '',
  });
  //#endregion

  // 스택형 뒤로가기로 변경: 작업 내역 목록에서는 홈으로 복귀
  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/Home'),
  });

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows ?? []);
    },
  });
  //#endregion

  const Init = () => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 내역'));
    dispatch(CommonActions.setActiveStep(0));
  };

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    Search1Async({
      userInfo,
      searchText: searchClick ? searchRef.current.searchText ?? '' : '',
    });
  }, [searchClick]);

  return (
    <div>
      <M_WOS_BASIC
        userInfo={userInfo}
        rowData1={rowData1}
        searchRef={searchRef}
        setSearchClick={setSearchClick}
        searchClick={searchClick}
      />
    </div>
  );
}

export default M_WOS_BASICF;
